import React from 'react';

/** Lazy ClientComputedTeamKpi (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedTeamKpi = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-team-kpi' */
            './ClientComputedTeamKpi'
        ),
);
